module.exports = __webpack_public_path__ + "static/img/OM13.737e3927.png";